import { useEffect, useState } from 'react';
import { type InsightsClient } from 'search-insights';

import { useFragmentContext } from '@jsmdg/react-fragment-scripts/fragment';
import { type ProductDetailContext } from '../types/types';

export const useInsightsClient = (): { insightsClient?: InsightsClient } => {
    const [insightsClient, setInsightsClient] = useState<InsightsClient | undefined>(undefined);
    const { algoliaConfig } = useFragmentContext<ProductDetailContext>();

    useEffect(() => {
        if (!algoliaConfig.userToken) {
            return;
        }

        // eslint-disable-next-line global-require, @typescript-eslint/no-var-requires
        const client: InsightsClient = require('search-insights');
        if (!client) {
            return;
        }

        client('init', {
            appId: algoliaConfig.appId,
            apiKey: algoliaConfig.searchKey,
            userToken: algoliaConfig.userToken,
        });
        setInsightsClient(() => client);
    }, [algoliaConfig.appId, algoliaConfig.searchKey, algoliaConfig.userToken]);

    return {
        insightsClient,
    };
};
